import React from "react";
import "../components/styles/Home.css";
import CodeEditor from "../components/CodeEditor";

const baseurl = "rizzapi.vercel.app/";

const GetAll = () => {
  return (
    <section id="getAll">
      <p className="endpoint">2. Get a list Pick-Up Lines</p>
      <div className="line"></div>
      Method: <span className="method">GET</span>
      <div className="dbline"></div>
      URL: <span className="method">{baseurl}list</span>
      <div className="dbline"></div>
      Description :
      <div className="idea">
        Retrieve a list of pickup lines from the database.
      </div>
      <div className="dbline"></div>
      Query Parameters
      <ul>
        <li>
          <span className="method">page </span>{" "}
          <div className="idea">
            (optional, default: 1) - The page number of results to retrieve.
          </div>
        </li>
        <li>
          <span className="method">perPage</span>
          <div className="idea">
            (optional, default: 20) - The number of responses to return per
            page.
          </div>
        </li>
      </ul>
      <br />
      <div className="line"></div>
      Example Request
      <CodeEditor>{`${baseurl}list?page=1&perPage=3`}</CodeEditor>
      <br />
      Response -{`>`}
      <br />
      The API will respond with a JSON object containing an array of pick-up
      lines. Each pick-up line is represented as a string
      <CodeEditor>
        {`[
  {
    "ratings": {
      "average": 0,
      "count": 0
    },
    "_id": "65146d31368fe07cfae3f90f",
    "text": "Are you Siri? Because you autocomplete me.",
    "category": "Cheesy",
    "language": "English",
    "tags": [],
    "usageExamples": [],
    "dateCreated": "2023-09-27T17:58:09.442Z",
    "comments": [],
    "__v": 0
  },
  {
    "ratings": {
      "average": 0,
      "count": 0
    },
    "_id": "65146d31368fe07cfae3f911",
    "text": "Are you a charger? Because I'm dying without you.",
    "category": "Flirty",
    "language": "English",
    "tags": [],
    "usageExamples": [],
    "dateCreated": "2023-09-27T17:58:09.477Z",
    "comments": [],
    "__v": 0
  },
  {
    "ratings": {
      "average": 0,
      "count": 0
    },
    "_id": "65146d31368fe07cfae3f913",
    "text": "Wanna be Minecraft without the craft?",
    "category": "Flirty",
    "language": "English",
    "tags": [],
    "usageExamples": [],
    "dateCreated": "2023-09-27T17:58:09.482Z",
    "comments": [],
    "__v": 0
  }
]
`}
      </CodeEditor>
      <span className="note">Note:</span>
      <div className="idea">
        Pagination is not available for certain specific endpoints, such as
        `/random`. For these endpoints, you will receive a single random pick-up
        line without pagination options.
      </div>
      <div className="line"></div>
    </section>
  );
};

export default GetAll;
